//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Cell, CellGroup } from 'vant'
export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      isExpand: false
    }
  },
  created () {
    this.$vux.loading.hide()
  },
  methods: {
    reigsterProcess: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/register'}, function (data) {
        console.log('functionSecelted')
      })
    },
    confirmProcess: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirmList'}, function (data) {
        console.log('functionSecelted')
      })
    },
    appointmentProcess: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/appointmentStep'}, function (data) {
        console.log('functionSecelted')
      })
    },
    appointmentconfirmProcess: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/appointmentConStep'}, function (data) {
        console.log('functionSecelted')
      })
    },
    contractProcess: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/contractStep'}, function (data) {
        console.log('functionSecelted')
      })
    },
    invite: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/invite'}, function (data) {
        console.log('functionSecelted')
      })
    },
    confirm: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/confirm'}, function (data) {
        console.log('functionSecelted')
      })
    },
    riskTest: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/risk'}, function (data) {
        console.log('functionSecelted')
      })
    },
    appointment: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/appointment'}, function (data) {
        console.log('functionSecelted')
      })
    },
    createProduct: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/createProduct'}, function (data) {
        console.log('functionSecelted')
      })
    },
    record: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/record'}, function (data) {
        console.log('functionSecelted')
      })
    },
    contract: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/contract'}, function (data) {
        console.log('functionSecelted')
      })
    },
    orderState: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/orderState'}, function (data) {
        console.log('functionSecelted')
      })
    },
    findPwd: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: '/guide/findPwd'}, function (data) {
        console.log('functionSecelted')
      })
    },
    recordList: function (event) {
      this.$bridge.callHandler('functionSecelted', {message: '详情说明', guideUrl: 'recordList'}, function (data) {
        console.log('recordList')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Guide/guideList.vue